module.exports = __webpack_public_path__ + "assets/b7e1e7412b20805594663c5e164a8e0d.mp3";